import { Button, Card, CardBody, Col, Modal, ModalBody, Row } from "reactstrap";
import premiumBoxImage from "../../assets/premium-box.png";
import { PremiumIcon } from "../../assets/designedPickedIcons";
import { useState } from "react";
import CheckedInput from "../inputs/CheckedInput";
import { Link } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import WhiteNavigator3 from "../navigators/WhiteNavigator3";

const GetPremium = ({ modalOpen, setModalOpen, onSuccess }) => {
  const [flowAt, setFlowAt] = useState(0);
  const [agreed, setAgreed] = useState(false);
  const [premiumTypeSelected, setPremiumTypeSelected] = useState(0);
  const premiumOptions = [
    { title: "1 Month", flowAt: 0 },
    { title: "3 Months", flowAt: 1 },
    { title: "6 Month", flowAt: 0 },
    { title: "1 Year", flowAt: 1 },
  ];

  const renderComponent = () => {
    switch (flowAt) {
      case 0:
        return (
          <>
            <h2 className="f-6 color-primary-blue text-center">Get Premium</h2>
            <p className="text-center color-primary-half-blue-3">
              Unlock all the power of this mobile tool and enjoy digital
              experience like never before!
            </p>
            <div className="mb-5">
              <WhiteNavigator3
                items={premiumOptions}
                flowAt={premiumTypeSelected}
                setFlowAt={setPremiumTypeSelected}
              />
            </div>
            <div className="d-flex align-items-center gap-2 flex-wrap flex-md-nowrap mb-4">
              <div className="premium-desc-point get">Use of discounts</div>
              <div className="premium-desc-point get">
                Larger appereance on map
              </div>
              <div className="premium-desc-point get">Use of commercials</div>
            </div>
            <div className="text-center">
              <img
                src={premiumBoxImage}
                height={200}
                alt="premium-box-image"
                className=" full-width object-fit-contain"
              />
            </div>

            <Card className="premium-card mb-4">
              <CardBody className="px-5 ">
                <div className="d-flex flex-wrap mb-3 align-items-center justify-content-between">
                  <h2 className="baloo-font f-6 text-white m-0">20 Chf</h2>
                  <PremiumIcon />
                </div>
                <h5 className="f-4 text-white mb-3 d-block ">
                  First 3 months free - Then 20 Chf/Month
                </h5>
              </CardBody>
            </Card>
            <Button
              onClick={() => setFlowAt(1)}
              className="standard-rounded-btn mb-4 btn-lg full-width"
            >
              Next
            </Button>
            <p className="f-4 text-center">
              By placing this order, you agree to the{" "}
              <span className="f-6 color-primary-blue">Terms of Service</span>{" "}
              and
              <span className="f-6 color-primary-blue"> Privacy Policy</span>.
              Subscription automatically renews every moth before the end of the
              current period with the E-Bill which goes to the E-Mail that you
              mark on this page
            </p>
          </>
        );

      case 1:
        return (
          <>
            <h3 className="f-6 color-primary-blue text-center">
              Terms & Conditions
            </h3>
            <p className="text-center color-primary-half-blue-3 my-4">
              By registering for our 3-month free trial, you agree to enjoy all
              premium features at no cost for the trial duration. This period
              allows us to collect valuable user feedback to refine our app and
              ensure it meets your needs. At the end of the trial, you can
              choose to subscribe to continue accessing premium features. By
              subscribing to the premium version of our activity map app, you
              agree to a monthly automatic renewal. The premium subscription
              grants access to exclusive features and enhanced functionalities.
              The subscription fee will be charged to the payment method
              associated with your account. You will receive a confirmation
              E-Bill email at the email provided during registration for each
              renewal. We reserve the right to modify or terminate the trial at
              any time. User data will be handled according to our Privacy
              Policy. Continued use of our app signifies your acceptance of
              these terms.
            </p>
            <div className="d-flex justify-content-center full-width gap-1 mb-5">
              <CheckedInput value={agreed} setValue={setAgreed} iconSize={25} />
              <p className="color-half-black-2 m-0">
                By tapping confirm , you agree to the{" "}
                <a
                  className="text-decoration-none text-primary"
                  href={"https://activity-maps.com/terms-conditions"}
                  target="_blank"
                >
                  terms of service
                </a>{" "}
                and{" "}
                <a
                  className="text-decoration-none text-primary"
                  href={"https://activity-maps.com/privacy-policy"}
                  target="_blank"
                >
                  privacy policy
                </a>
              </p>
            </div>
            <Row className="justify-content-center g-0">
              <Col md={9}>
                <Button
                  onClick={() => {
                    setModalOpen(false);
                    setFlowAt(0);
                    onSuccess();
                  }}
                  className="standard-rounded-btn full-width btn-lg f-6"
                >
                  Next
                </Button>
              </Col>
            </Row>
          </>
        );
    }
  };

  return (
    <Modal
      className="modal-md-custom"
      centered
      fade={false}
      isOpen={modalOpen}
      toggle={() => setModalOpen((prev) => !prev)}
    >
      <ModalBody
        className="bg-white py-4 position-relative"
        style={{ borderRadius: "28.24px" }}
      >
        <Button
          onClick={() => setModalOpen(false)}
          className="bg-primary-blue d-flex align-items-center justify-content-center p-0 position-absolute full-rounded "
          style={{ height: 44, width: 44, left: 15, top: 15 }}
        >
          <RxCross2 strokeWidth={`1px`} size={18} />
        </Button>

        <Row className="g-0 justify-content-center">
          <Col md={11} xl={11} className="p-0">
            {renderComponent()}
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default GetPremium;
